import Q from 'q';
import find from 'lodash/find';
import get from 'lodash/get';
import each from 'lodash/each';
import endsWith from 'lodash/endsWith';
import head from 'lodash/head';
import isArray from 'lodash/isArray';
import {
  FIELDS_TYPES, 
  getFieldsType, 
  findPniScreenId,
  filterDynamicFormResponses,
} from 'shared/lib/utils';
import api from '../../api';
import ACTION_TYPES from '../../constants/actionTypes';

/**
 * Submit endorsement address, get endorsement form add
 */

function getCollectiblesEndorsementAddFormRequest(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_ADD_FORM,
    data,
  };
}

function getCollectiblesEndorsementAddFormSuccess(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_ADD_FORM_SUCCESS,
    data,
  };
}

function getCollectiblesEndorsementAddFormFailure(error) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_ADD_FORM_FAILURE,
    error,
  };
}

export function getCollectiblesEndorsementAddForm({ categoryCode, policyId }) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        authToken,
        collectiblesEndorsementPropertyAddress,
        collectiblesEndorsementResponses,
      } = getState();

      dispatch(getCollectiblesEndorsementAddFormRequest({ 
        collectiblesEndorsementPropertyAddress, 
        collectiblesEndorsementResponses,
        categoryCode,
        policyId,
      }));

      api
        .getCollectiblesEndorsementAddForm({
          authToken,
          categoryCode,
          policyId,
          ...collectiblesEndorsementPropertyAddress,
        })
        .then((response) => {
          if (response.start_screen_id === findPniScreenId(response.screens)) {
            response.start_screen_id = response.screens[response.start_screen_id].next_screen_id;
          }
          dispatch(getCollectiblesEndorsementAddFormSuccess(response));
          resolve(response);
        })
        .catch((error) => {
          dispatch(getCollectiblesEndorsementAddFormFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Submit endorsement details, get endorsement checkout add
 */

function getCollectiblesEndorsementAddCheckoutRequest(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_ADD_CHECKOUT,
    payload: data,
  };
}

function getCollectiblesEndorsementAddCheckoutSuccess(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_ADD_CHECKOUT_SUCCESS,
    payload: data,
  };
}

function getCollectiblesEndorsementAddCheckoutFailure(error) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_ADD_CHECKOUT_FAILURE,
    error,
  };
}

export function getCollectiblesEndorsementAddCheckout({ categoryCode, policyId }) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        authToken,
        collectiblesEndorsementPropertyAddress,
        collectiblesEndorsementResponses,
        collectiblesEndorsementScreens,
      } = getState();

      dispatch(getCollectiblesEndorsementAddCheckoutRequest({ 
        collectiblesEndorsementPropertyAddress, 
        collectiblesEndorsementResponses,
        categoryCode,
        policyId,
      }));

      const details = filterDynamicFormResponses(collectiblesEndorsementScreens, collectiblesEndorsementResponses);
      each(details, (val, key) => {
        if (endsWith(key, '_dob')) {
          let [month, day, year] = val.split('/');
          details[key] = [year, month, day].join('-');
        }
      });

      api
        .getCollectiblesEndorsementAddCheckout({
          authToken,
          categoryCode,
          policyId,
          details,
          ...collectiblesEndorsementPropertyAddress,
        })
        .then((response) => {
          dispatch(getCollectiblesEndorsementAddCheckoutSuccess(response));
          resolve(response);
        })
        .catch((error) => {
          dispatch(getCollectiblesEndorsementAddCheckoutFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Purchase collectibles endorsement add
 */

function purchaseCollectiblesEndorsementAddStart() {
  return {
    type: ACTION_TYPES.PURCHASE_COLLECTIBLES_ENDORSEMENT_ADD,
  };
}

function purchaseCollectiblesEndorsementAddSuccess(data) {
  return {
    type: ACTION_TYPES.PURCHASE_COLLECTIBLES_ENDORSEMENT_ADD_SUCCESS,
    payload: data,
  };
}

function purchaseCollectiblesEndorsementAddError(error) {
  return {
    type: ACTION_TYPES.PURCHASE_COLLECTIBLES_ENDORSEMENT_ADD_FAILURE,
    error,
  };
}

export function purchaseCollectiblesEndorsementAdd({ cardElement, categoryCode, policyId }) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        firstName,
        lastName,
        email,
        phoneNumber,
      } = getState().account;
      const {
        authToken, 
        collectiblesEndorsementPropertyAddress,
        collectiblesEndorsementQuote, 
        collectiblesEndorsementResponses, 
        collectiblesEndorsementScreens, 
        metadata,
      } = getState();
      const revenue = collectiblesEndorsementQuote.cart.totals.grandtotal;

      const details = filterDynamicFormResponses(collectiblesEndorsementScreens, collectiblesEndorsementResponses);
      each(details, (val, key) => {
        if (endsWith(key, '_dob')) {
          let [month, day, year] = val.split('/');
          details[key] = [year, month, day].join('-');
        }
      });

      const opts = {
        authToken,
        firstName,
        lastName,
        phoneNumber,
        email,
        revenue,
        cardElement,
        details,
        categoryCode,
        policyId,
        metadata,
        ...collectiblesEndorsementPropertyAddress,
      };

      dispatch(purchaseCollectiblesEndorsementAddStart());
      api
        .purchaseCollectiblesEndorsementAdd(opts)
        .then((purchaseData) => {
          const hydratedPurchaseData = {
            details,
            categoryCode,
            policyId,
            metadata,
            quote: collectiblesEndorsementQuote,
            propertyAddress: collectiblesEndorsementPropertyAddress,
            ...purchaseData,
          };
          dispatch(purchaseCollectiblesEndorsementAddSuccess(hydratedPurchaseData));
          resolve(hydratedPurchaseData);
        })
        .catch((err) => {
          dispatch(purchaseCollectiblesEndorsementAddError(err.response.body.error));
          reject(err.response.body.error);
        });
    });
  };
}

/**
 * Submit endorsement address, get endorsement edit form
 */

function getCollectiblesEndorsementEditFormRequest(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_EDIT_FORM,
    data,
  };
}

function getCollectiblesEndorsementEditFormSuccess(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_EDIT_FORM_SUCCESS,
    data,
  };
}

function getCollectiblesEndorsementEditFormFailure(error) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_EDIT_FORM_FAILURE,
    error,
  };
}

export function getCollectiblesEndorsementEditForm({ categoryCode, policyId }) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        authToken,
        collectiblesEndorsementPropertyAddress,
        collectiblesEndorsementResponses,
      } = getState();

      dispatch(getCollectiblesEndorsementEditFormRequest({ 
        collectiblesEndorsementPropertyAddress, 
        collectiblesEndorsementResponses,
        categoryCode,
        policyId,
      }));

      api
        .getCollectiblesEndorsementEditForm({
          authToken,
          categoryCode,
          policyId,
          ...collectiblesEndorsementPropertyAddress,
        })
        .then((response) => {
          if (response.start_screen_id === findPniScreenId(response.screens)) {
            response.start_screen_id = response.screens[response.start_screen_id].next_screen_id;
          }
          dispatch(getCollectiblesEndorsementEditFormSuccess(response));
          resolve(response);
        })
        .catch((error) => {
          dispatch(getCollectiblesEndorsementEditFormFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Submit endorsement details, get endorsement edit checkout
 */

function getCollectiblesEndorsementEditCheckoutRequest(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_EDIT_CHECKOUT,
    payload: data,
  };
}

function getCollectiblesEndorsementEditCheckoutSuccess(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_EDIT_CHECKOUT_SUCCESS,
    payload: data,
  };
}

function getCollectiblesEndorsementEditCheckoutFailure(error) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_EDIT_CHECKOUT_FAILURE,
    error,
  };
}

export function getCollectiblesEndorsementEditCheckout({ categoryCode, policyId }) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        authToken,
        collectiblesEndorsementPropertyAddress,
        collectiblesEndorsementResponses,
        collectiblesEndorsementScreens,
      } = getState();

      dispatch(getCollectiblesEndorsementEditCheckoutRequest({ 
        collectiblesEndorsementPropertyAddress, 
        collectiblesEndorsementResponses,
        categoryCode,
        policyId,
      }));

      const details = filterDynamicFormResponses(collectiblesEndorsementScreens, collectiblesEndorsementResponses);
      each(details, (val, key) => {
        if (endsWith(key, '_dob')) {
          let [month, day, year] = val.split('/');
          details[key] = [year, month, day].join('-');
        }
      });

      api
        .getCollectiblesEndorsementEditCheckout({
          authToken,
          categoryCode,
          policyId,
          details,
          ...collectiblesEndorsementPropertyAddress,
        })
        .then((response) => {
          dispatch(getCollectiblesEndorsementEditCheckoutSuccess(response));
          resolve(response);
        })
        .catch((error) => {
          dispatch(getCollectiblesEndorsementEditCheckoutFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Purchase collectibles endorsement edit
 */

function purchaseCollectiblesEndorsementEditStart() {
  return {
    type: ACTION_TYPES.PURCHASE_COLLECTIBLES_ENDORSEMENT_EDIT,
  };
}

function purchaseCollectiblesEndorsementEditSuccess(data) {
  return {
    type: ACTION_TYPES.PURCHASE_COLLECTIBLES_ENDORSEMENT_EDIT_SUCCESS,
    payload: data,
  };
}

function purchaseCollectiblesEndorsementEditError(error) {
  return {
    type: ACTION_TYPES.PURCHASE_COLLECTIBLES_ENDORSEMENT_EDIT_FAILURE,
    error,
  };
}

export function purchaseCollectiblesEndorsementEdit({ cardElement, categoryCode, policyId }) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const {
        firstName,
        lastName,
        email,
        phoneNumber,
      } = getState().account;
      const {
        authToken, 
        collectiblesEndorsementPropertyAddress,
        collectiblesEndorsementQuote, 
        collectiblesEndorsementResponses, 
        collectiblesEndorsementScreens, 
        metadata,
      } = getState();
      const revenue = collectiblesEndorsementQuote.cart.totals.grandtotal;

      const details = filterDynamicFormResponses(collectiblesEndorsementScreens, collectiblesEndorsementResponses);
      each(details, (val, key) => {
        if (endsWith(key, '_dob')) {
          let [month, day, year] = val.split('/');
          details[key] = [year, month, day].join('-');
        }
      });

      const opts = {
        authToken,
        firstName,
        lastName,
        phoneNumber,
        email,
        revenue,
        cardElement,
        details,
        categoryCode,
        policyId,
        metadata,
        ...collectiblesEndorsementPropertyAddress,
      };

      dispatch(purchaseCollectiblesEndorsementEditStart());
      api
        .purchaseCollectiblesEndorsementEdit(opts)
        .then((purchaseData) => {
          const hydratedPurchaseData = {
            details,
            categoryCode,
            policyId,
            metadata,
            quote: collectiblesEndorsementQuote,
            propertyAddress: collectiblesEndorsementPropertyAddress,
            ...purchaseData,
          };
          dispatch(purchaseCollectiblesEndorsementEditSuccess(hydratedPurchaseData));
          resolve(hydratedPurchaseData);
        })
        .catch((err) => {
          dispatch(purchaseCollectiblesEndorsementEditError(err.response.body.error));
          reject(err.response.body.error);
        });
    });
  };
}

/**
 * Get an endorsement removal checkout
 */

function getCollectiblesEndorsementRemoveCheckoutRequest(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_REMOVE_CHECKOUT,
    payload: data,
  };
}

function getCollectiblesEndorsementRemoveCheckoutSuccess(data) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_REMOVE_CHECKOUT_SUCCESS,
    payload: data,
  };
}

function getCollectiblesEndorsementRemoveCheckoutFailure(error) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_ENDORSEMENT_REMOVE_CHECKOUT_FAILURE,
    error,
  };
}

export function getCollectiblesEndorsementRemoveCheckout({ categoryCode, policyId }) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { authToken } = getState();

      dispatch(getCollectiblesEndorsementRemoveCheckoutRequest({ 
        categoryCode,
        policyId,
      }));

      api
        .getCollectiblesEndorsementRemoveCheckout({
          authToken,
          categoryCode,
          policyId,
        })
        .then((response) => {
          dispatch(getCollectiblesEndorsementRemoveCheckoutSuccess(response));
          resolve(response);
        })
        .catch((error) => {
          dispatch(getCollectiblesEndorsementRemoveCheckoutFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Submit an endorsement removal checkout
 */

function submitCollectiblesEndorsementRemoveRequest(data) {
  return {
    type: ACTION_TYPES.SUBMIT_COLLECTIBLES_ENDORSEMENT_REMOVE,
    payload: data,
  };
}

function submitCollectiblesEndorsementRemoveSuccess(data) {
  return {
    type: ACTION_TYPES.SUBMIT_COLLECTIBLES_ENDORSEMENT_REMOVE_SUCCESS,
    payload: data,
  };
}

function submitCollectiblesEndorsementRemoveFailure(error) {
  return {
    type: ACTION_TYPES.SUBMIT_COLLECTIBLES_ENDORSEMENT_REMOVE_FAILURE,
    error,
  };
}

export function submitCollectiblesEndorsementRemove({ categoryCode, policyId }) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { authToken } = getState();

      dispatch(submitCollectiblesEndorsementRemoveRequest({ 
        categoryCode,
        policyId,
      }));

      api
        .submitCollectiblesEndorsementRemove({
          authToken,
          categoryCode,
          policyId,
        })
        .then((response) => {
          dispatch(submitCollectiblesEndorsementRemoveSuccess(response));
          resolve(response);
        })
        .catch((error) => {
          dispatch(submitCollectiblesEndorsementRemoveFailure(error));
          reject(error);
        });
    });
  };
}

/**
 *  Update address
 */

export function updateCollectiblesEndorsementAddress(address) {
  return {
    type: ACTION_TYPES.UPDATE_COLLECTIBLES_ENDORSEMENT_ADDRESS,
    address,
  };
}

/**
 *  Survey
 */

export function collectiblesEndorsementSurveyNext() {
  return {
    type: ACTION_TYPES.COLLECTIBLES_ENDORSEMENT_SURVEY_NEXT,
  };
}

function selectCollectiblesEndorsementChoiceByFieldAndValue(field, value, dispatch) {
  const choice = find(field.settings.choices, { value: value });
  if (choice && choice.screen_id) {
    dispatch({
      type: ACTION_TYPES.SELECT_COLLECTIBLES_ENDORSEMENT_CHOICE,
      screen_id: choice.screen_id,
    });
  }
}

export function updateCollectiblesEndorsementCurrentResponse(response) {
  return {
    type: ACTION_TYPES.UPDATE_COLLECTIBLES_ENDORSEMENT_CURRENT_RESPONSE,
    payload: {
      response,
    },
  };
}

export function saveCollectiblesEndorsementResponse(response) {
  return (dispatch, getState) => {
    const { collectiblesEndorsementScreens, collectiblesEndorsementCurrentScreenId } = getState();
    const screen = collectiblesEndorsementScreens[collectiblesEndorsementCurrentScreenId];
    const fieldsType = getFieldsType(get(screen, 'fields'));

    if (fieldsType === FIELDS_TYPES.SINGLE_SELECT || fieldsType === FIELDS_TYPES.MULTI_SELECT) {
      const field = head(screen.fields);
      each(response, (value, key) => {
        if (isArray(value)) {
          each(value, (_value) => {
            selectCollectiblesEndorsementChoiceByFieldAndValue(field, _value, dispatch);
          });
        } else {
          selectCollectiblesEndorsementChoiceByFieldAndValue(field, value, dispatch);
        }
      });
    }

    dispatch({
      type: ACTION_TYPES.SAVE_COLLECTIBLES_ENDORSEMENT_RESPONSE,
      response,
    });

    const deferred = Q.defer();
    deferred.resolve();
    return deferred.promise;
  };
}

export function deleteCollectiblesEndorsementResponse(responseKeys = []) {
  return {
    type: ACTION_TYPES.DELETE_COLLECTIBLES_ENDORSEMENT_RESPONSE,
    payload: {
      responseKeys,
    },
  };
}

export function surveyCollectiblesEndorsementBack() {
  return {
    type: ACTION_TYPES.COLLECTIBLES_ENDORSEMENT_SURVEY_BACK,
  };
}

export function resetCollectiblesEndorsementData() {
  return {
    type: ACTION_TYPES.RESET_COLLECTIBLES_ENDORSEMENT_DATA,
  };
}

/*
 * Categories
 * ========================================
 */

function getCollectiblesCategoriesRequest() {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_CATEGORIES,
  };
}

function getCollectiblesCategoriesSuccess(categories = []) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_CATEGORIES_SUCCESS,
    payload: {
      categories,
    },
  };
}

function getCollectiblesCategoriesFailure(error) {
  return {
    type: ACTION_TYPES.GET_COLLECTIBLES_CATEGORIES_FAILURE,
    error,
  };
}

export function getCollectiblesCategories() {
  return (dispatch, getState) => {
    const { 
      authToken,
      collectiblesCategories,
    } = getState();
    return new Promise((resolve, reject) => {
      dispatch(getCollectiblesCategoriesRequest());

      if (collectiblesCategories.length) {
        dispatch(getCollectiblesCategoriesSuccess(collectiblesCategories));
        resolve(collectiblesCategories);
      } else {
        api
          .getCollectiblesCategories({ authToken })
          .then((categories) => {
            dispatch(getCollectiblesCategoriesSuccess(categories));
            resolve(categories);
          })
          .catch((error) => {
            dispatch(getCollectiblesCategoriesFailure(error));
            reject(error);
          });
      }

    });
  };
};
